import { render, staticRenderFns } from "./total-label.vue?vue&type=template&id=855ecf26"
import script from "./total-label.vue?vue&type=script&lang=js"
export * from "./total-label.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports